'use client';
import dynamic from 'next/dynamic';
import { Suspense, useEffect } from 'react';
import { type GlobalNavData } from '../../../services/globalNavItems/types';
import { HamburgerToggle } from '../../Header/MobileNav/HamburgerToggle';
import { useMobileNavBodyScrollLock } from '../../Header/MobileNav/hooks';
import { useDropdownContext } from '../../DropdownProvider';
import { useWindowDimensions } from '../../../hooks/useWindowDimensions';
import { CLOSE_ALL_ACTION } from '../../DropdownProvider/useSingleDropdown';

const MobileNavMenu = dynamic(
  () => import('../MobileFlatNavMenu').then(module => ({ default: module.MobileNavMenu })),
  { ssr: false },
);

type MobileNavProps = {
  navData: GlobalNavData;
};

export function MobileFlatNav({ navData }: MobileNavProps) {
  const { dispatch, state } = useDropdownContext();
  const dimensions = useWindowDimensions();
  useMobileNavBodyScrollLock();

  useEffect(() => {
    if (state.isShowingMobileNav && !['xs', 'sm', 'md'].includes(dimensions.screenSize)) {
      dispatch(CLOSE_ALL_ACTION);
    }
  }, [dimensions.width]);

  return (
    <>
      <HamburgerToggle />
      <Suspense fallback={null}>
        <MobileNavMenu l1Menu={navData.l1Menu} />
      </Suspense>
    </>
  );
}
